import httpClient from '@/http-client'

export const formModel = () => httpClient.get('/api/telegram-messages/form-view-models')
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export const send = data => httpClient.post('/api/telegram-messages', data)
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export const find = id => httpClient.get(`/api/telegram-messages/${id}`)
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export const update = (id, data) => httpClient.post(`/api/telegram-messages/${id}`, data)
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export const detail = (id, options = {}) => httpClient.get(`/api/telegram-messages/${id}/detail`, options)
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export const history = (options = {}) => httpClient.get('/api/telegram-messages', options)
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export const destroy = id => httpClient.delete(`/api/telegram-messages/${id}`)
  .then(response => response.data)
  .catch(error => Promise.reject(error.response.data))

export default { formModel, send, find, update, detail, history, destroy }
